var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-subscription-price-box px-3 position-relative"},[_c('filter-slider-box',{attrs:{"filter-title":"price","append-content":_vm.$t('cat.filter.currency'),"title":_vm.$t('cat.filter.price'),"show-title":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }